// extracted by mini-css-extract-plugin
export default {"buyPop":"CancelOrderConfirmationPopup_buyPop__KJEI4","price":"CancelOrderConfirmationPopup_price__j6XNp"};